import React, { useState, useEffect, useRef } from "react";
import heroImg from "../components/assets/images/hero-alt.png";
import heroImgback from "../components/assets/images/hero-shape-purple.png";
import { About } from "./About";
import { WhyUs } from "./WhyUs";
import SubMenu from "../components/common/SubMenu";
import { motion, AnimatePresence } from "framer-motion";
import { db } from "../components/firebase/firebase";
import { collection, getDocs } from "firebase/firestore";
import Loader from "../components/common/Loader";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import Modals from "../components/common/Modals";

export const Home = () => {
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const snapshot = await getDocs(collection(db, "resources"));
        setPapers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (e) {
        console.error("Error fetching papers:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchPapers();
  }, []);

  if (loading) return <Loader />;

  const sorted = [...papers].sort((a, b) => {
    const dA = new Date(a.year, new Date(a.month + " 1, 2024").getMonth());
    const dB = new Date(b.year, new Date(b.month + " 1, 2024").getMonth());
    return dB - dA;
  });
  const lastFive = sorted.slice(0, 5);

  return (
    <>
      {/* ─── CONNECT WITH US BAR ─── */}
            <div className="bg-blue-600 py-2">
        <div className="container mx-auto px-4 flex flex-wrap justify-center gap-6 items-center">
          <a href="https://www.facebook.com/groups/2539806196195532/?ref=share&mibextid=NSMWBT" aria-label="Facebook">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/1/1b/Facebook_icon.svg"
              alt="Facebook"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://youtube.com/@ravitestpapers?si=C8smjrPiXabNI54Y" aria-label="Instagram">
            <img
              src="https://img.freepik.com/premium-vector/round-youtube-logo-isolated-white-background_469489-983.jpg?semt=ais_hybrid&w=740"
              alt="Youtube"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://twitter.com/Ravimathssir" aria-label="Twitter">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiHIZuDb--IJ-q5d97gWm1W2eyLj7BePcWnQ&s"
              alt="Twitter"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="http://www.linkedin.com/in/ravi-s-093838310" aria-label="LinkedIn">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
              alt="LinkedIn"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://wa.me/qr/DO3TUISQWWSCH1" aria-label="WhatsApp">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://t.me/FREESTUDYMATERIALSRAVISIR" aria-label="Telegram">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg"
              alt="Telegram"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
          <a href="https://WWW.ravitestpapers.in" aria-label="Website">
            <img
              src="https://i.pinimg.com/736x/86/c3/05/86c30529904c3a992eb7241299e5f3e5.jpg"
              alt="Website"
              className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
            />
          </a>
        </div>
      </div>

      <Modals />
      <HomeContent />
      <LastFivePapers papers={lastFive} />
      <About />
      <div className="py-12" />
      <WhyUs />
    </>
  );
};

export const HomeContent = () => {
  const [index, setIndex] = useState(0);
  const words = ["Exam Success", "Test Excellence", "Academic Achievement"];

  useEffect(() => {
    const t = setInterval(() => setIndex(i => (i + 1) % words.length), 3000);
    return () => clearInterval(t);
  }, [words.length]);

  return (
    <section className="bg-secondary py-10 h-[92vh] md:h-auto">
      <SubMenu />
      <div className="container mx-auto flex items-center justify-between md:flex-col">
        <div className="w-1/2 md:w-full">
          <motion.h1
            className="text-4xl lg:text-7xl font-bold leading-tight text-black opacity-100"
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 60, damping: 20 }}
          >
            Welcome to <span className="text-blue-500">Ravi</span> TestPapers
          </motion.h1>
          <motion.h3
            className="mt-5 text-lg lg:text-2xl ml-3"
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 60, damping: 20, delay: 0.75 }}
          >
            One stop destination for{" "}
            <AnimatePresence mode="wait">
              <motion.span
                key={words[index]}
                className="text-blue-500 font-semibold"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                {words[index]}
              </motion.span>
            </AnimatePresence>
          </motion.h3>
          <button className="mt-12 ml-4 py-2 px-6 bg-white text-blue-600 rounded-3xl font-semibold hover:bg-blue-600 hover:text-white transition">
            Explore More
          </button>
        </div>
        <div className="w-1/2 md:w-full relative">
          <motion.img
            src={heroImgback}
            alt="Background Shape"
            className="absolute top-32 left-10 w-96"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          />
          <motion.img
            src={heroImg}
            alt="Hero"
            className="relative z-20 h-[85vh] w-full object-contain"
            initial={{ y: -50 }}
            animate={{ y: 0 }}
            transition={{
              type: "spring",
              stiffness: 120,
              damping: 90,
              mass: 2,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut",
            }}
          />
        </div>
      </div>
    </section>
  );
};

const LastFivePapers = ({ papers }) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  const slides = [...papers, ...papers];

  useEffect(() => {
    if (ref.current) setWidth(ref.current.scrollWidth / 2);
  }, [papers]);

  const getImage = item => item.thumbnail || "https://via.placeholder.com/450x300?text=No+Image";

  return (
    <section className="bg-gray-100 py-8">
      <div className="container mx-auto">
        <h2 className="text-2xl font-semibold mb-4">Latest Papers</h2>
        <div ref={ref} className="overflow-hidden">
          <motion.div
            className="flex space-x-4"
            animate={{ x: -width }}
            transition={{ duration: 20, ease: "linear", repeat: Infinity }}
          >
            {slides.map((p, i) => (
              <motion.div
                key={i}
                className="bg-white rounded-lg shadow min-w-[450px] p-2 flex-shrink-0"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: (i % papers.length) * 0.1 }}
              >
                <div className="relative h-40 overflow-hidden rounded-t-lg">
                  <img
                    src={getImage(p)}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform hover:scale-110"
                  />
                  <div className="absolute top-2 left-2 flex gap-2">
                    <span className="bg-red-500 text-white px-2 rounded">{p.subject}</span>
                    <span className="bg-green-500 text-white px-2 rounded">{p.month} {p.year}</span>
                  </div>
                </div>
                <h3 className="mt-3 font-medium h-10 overflow-hidden">{p.title}</h3>
                <div className="mt-4 flex justify-between items-center border-t pt-2">
                  {p.referenceLink && (
                    <a href={p.referenceLink} target="_blank" rel="noopener noreferrer" className="text-primary">
                      Reference
                    </a>
                  )}
                  <a href={p.link} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary">
                    View Paper <HiOutlineArrowNarrowRight className="ml-1" />
                  </a>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Home;
